import { HistoryListProps } from "@husky-x/history-list";

export const HistoryMock: HistoryListProps  = {
	data: [
		{
			year: 1915,
			description: 'LA Jackson, London Rubber Company\'yi kurarak ithal berber prezervatifleri ve aksesuarlar sattı.',
		},
		{
			year: 1929,
			description: 'The London Rubber Company (LRC) Durex markasını tescil ettirdi.',
		},
		{
			year: '1950\'ler',
			description: 'Durex ilk nemlendirilmiş prezervatifini piyasaya sürdü',
		},
		{
			year: 1953,
			description: 'Durex elektronik test geliştiren ve kullanan ilk marka oldu.',
		},
		{
			year: '1960\'larda',
			description: 'Durex anatomiye uygun olarak şekillendirilmiş ilk prezervatifi piyasaya sürdü.',
		},
		{
			year: '1970\'ler',
			description: 'Durex dünyada birçok ülkede reklam yapan ilk prezervatif markası oldu.',
		},
		{
			year: '1990\'lar',
			description: 'Durex, standart olarak "kalite mührünü" benimseyen ilk prezervatif markası oldu.',
		},
		{
			year: 1995,
			description: 'Durex çeşitli renkli ve aromalı prezervatifleri piyasaya sürdü.',
		},
		{
			year: 1996,
			description: 'Durex, web sitesi kuran ilk prezervatif markası oldu. Günümüzde yer aldığımız ülkelerde 42 farklı web sitemiz var.',
		},
		{
			year: 1997,
			description: 'Durex lateks içermeyen prezervatifleri piyasaya sürdü. Yeni ürün için, alerjik olmayan bir malzeme kullanıldı: Durex tarafından geliştirilen sentetik poliüretan, doğal kauçuk lateksten daha yumuşak ve esnekti.',
		},
		{
			year: 1998,
			description: 'Durex, dünya çapında bir cinsel sağlık anketi gerçekleştiren ve yayımlayan ilk prezervatif markası oldu.',
		},
		{
			year: 2001,
			description: 'Durex Pleasuremax\'ı piyasaya sürdü. Bu, Durex\'i hem tırtıklı hem de noktalı bir prezervatifi pazarlayan ilk prezervatif markası yaptı.',
		},
		{
			year: 2003,
			description: 'Durex heyecan verici Play Kayganlaştırıcı serisini piyasaya sürdü.',
		},
		{
			year: 2005,
			description: 'Durex Network, cinsel davranışları araştıran Küresel Seks Yüzü raporlarını yayınladı, bu rapor akademisyenlerin ve politika yapıcıların bilgi edinmeleri için oluşturulmuş bir kaynak haline geldi.',
		},
		{
			year: 2008,
			description: 'Durex, gençler arasında güvenli cinsel ilişkiyi teşvik etmek için 16 ila 24 yaş arasındaki gençleri cinsel sağlık üzerine bir poster yaratmaya teşvik etti.',
		},
		{
			year: 2009,
			description: 'Durex 80 yaşında.',
		},
		{
			year: 2010,
			description: 'Durex "Prezervatif Kullan!" hareketi için, Viyana\'daki Uluslararası AIDS Konferansı\'nda Birleşmiş Milletler Nüfus Fonu hareketine 220.000 prezervatif bağışladı.',
		},
		{
			year: 2010,
			description: 'Durex, Reckitt Benckiser tarafından satın alındı.',
		},
		{
			year: 2010,
			description: 'Durex, içinde % 5 benzocaine içeren ve tırtıklı dış yapıya sahip Performax Intense adlı prezervatifi piyasaya sürdü. Bu ürün çiftlerin daha uzun ve yoğun bir seks deneyimi yaşamasına yardımcı olmak için tasarlandı.',
		},
		{
			year: 2019,
			description: 'Durex 90 yaşında!',
		},
		{
			year: 2022,
			description: 'Durex yeni marka dünyasını hayata geçirdi',
		},
	]
}